import { render, staticRenderFns } from "./FsDirectoryInfo.vue?vue&type=template&id=4b70201e&"
import script from "./FsDirectoryInfo.vue?vue&type=script&lang=js&"
export * from "./FsDirectoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports